import React from 'react';

export default function Video({ video }) {
	return <video src={video} controls></video>;
}
